import type { RichContent } from 'ricos-schema';

import { getDefaultAudioUrl, getDefaultVideoUrl } from './convertNodes';
import { toPlainTextBase } from './to-plain-text-base';

interface PlainTextOptions {
  urlShortener?: (url: string) => Promise<string>;
  getVideoUrl?: (fileId: string) => Promise<string>;
  getVideoEmbeddedUrl?: (url: string) => Promise<string>;
  getAudioUrl?: (fileId: string) => Promise<string>;
  getGifUrl?: (url: string) => Promise<string>;
  addLinksToText?: boolean;
  delimiter?: string;
}

export const toPlainText = async (content: RichContent, options: PlainTextOptions = {}) => {
  const gen = toPlainTextBase(content, options.delimiter, options.addLinksToText);
  let next = gen.next();

  while (!next.done) {
    switch (next.value.command) {
      case 'getImageUrl': {
        const url = options.urlShortener
          ? await options.urlShortener?.(next.value.data)
          : next.value.data;
        next = gen.next(url);
        break;
      }
      case 'getVideoUrl': {
        const url = await (options.getVideoUrl
          ? options.getVideoUrl(next.value.data)
          : getDefaultVideoUrl(next.value.data));
        next = gen.next(url);
        break;
      }
      case 'getVideoEmbeddedUrl': {
        const url = await (options.getVideoEmbeddedUrl
          ? options.getVideoEmbeddedUrl(next.value.data)
          : next.value.data);
        next = gen.next(url);
        break;
      }
      case 'getAudioUrl': {
        const url = await (options.getAudioUrl
          ? options.getAudioUrl(next.value.data)
          : getDefaultAudioUrl(next.value.data));
        next = gen.next(url);
        break;
      }
      case 'getGifUrl': {
        const url = await (options.getGifUrl
          ? options.getGifUrl(next.value.data)
          : next.value.data);
        next = gen.next(url);
        break;
      }
      default:
        return '';
    }
  }

  return next.value;
};
